<template>
  <div>

    <section class="section is-medium">
      <div class="container">
        <h1 v-if="isNewsletter" class="title">Newsletter Survey: {{ feedbackForm.formName }}  <div class="dropdown is-hoverable">
          <div class="dropdown-trigger is-pulled-right">
            <b-icon
              icon="more-vertical"
              size="is-small"
              aria-haspopup="true"
              aria-controls="dropdown-menu4"
            ></b-icon>
          </div>
          <div class="dropdown-menu" id="dropdown-menu4" role="menu">
            <div class="dropdown-content">
              <a class="dropdown-item" @click.prevent="confirmReset">
                Reset Analytics
              </a>
              <a class="dropdown-item" @click.prevent="confirmDelete">
                Delete Survey
              </a>
              
            </div>
          </div>
        </div></h1>
        <h1 v-else-if="isWebRating" class="title">Web Rating: {{ feedbackForm.formName }} <div class="dropdown is-hoverable">
          <div class="dropdown-trigger is-pulled-right">
            <b-icon
              icon="more-vertical"
              size="is-small"
              aria-haspopup="true"
              aria-controls="dropdown-menu4"
            ></b-icon>
          </div>
          <div class="dropdown-menu" id="dropdown-menu4" role="menu">
            <div class="dropdown-content">
              <a class="dropdown-item" @click.prevent="confirmReset">
                Reset Analytics
              </a>
              <a class="dropdown-item" @click.prevent="confirmDelete">
                Delete Survey
              </a>
              
            </div>
          </div>
        </div></h1>
        <h1 v-else class="title">Onetime Poll: {{ feedbackForm.formName }}  <div class="dropdown is-hoverable">
          <div class="dropdown-trigger is-pulled-right">
            <b-icon
              icon="more-vertical"
              size="is-small"
              aria-haspopup="true"
              aria-controls="dropdown-menu4"
            ></b-icon>
          </div>
          <div class="dropdown-menu" id="dropdown-menu4" role="menu">
            <div class="dropdown-content">
              <a class="dropdown-item" @click.prevent="confirmReset">
                Reset Analytics
              </a>
              <a class="dropdown-item" @click.prevent="confirmDelete">
                Delete Survey
              </a>
              
            </div>
          </div>
        </div></h1>
        
        <div class="columns is-centered">
          <div class="column is-half">
            <article
              id="createdMessage"
              v-if="$route.query.created && showCreatedMsg"
              class="message is-success mb-6"
            >
              <div class="message-header">
                <p>Success</p>
                <button
                  class="delete"
                  aria-label="delete"
                  @click.prevent="showCreatedMsg = false"
                ></button>
              </div>
              <div class="message-body">
                The {{ surveyTypeText }} was successfully created. Now copy the
                feedback block below and paste it into your email.
              </div>
            </article>
          </div>
        </div>
        <div class="tabs is-boxed mb-0">
          <ul>
            <li v-bind:class="{ 'is-active': activeTab == 0 }">
              <a @click.prevent="activeTab = 0">Analytics</a>
            </li>
            <li v-bind:class="{ 'is-active': activeTab == 1 }">
              <a @click.prevent="activeTab = 1">Edit</a>
            </li>
            <li v-bind:class="{ 'is-active': activeTab == 2 }">
              <a @click.prevent="activeTab = 2">Code</a>
            </li>
          </ul>
        </div>
<div class="tab-panel">
        <div v-if="activeTab == 0">
          <div class="columns is-centered">
            <div class="column is-half">


<div class="box">
                <div class="block chart-center">
                  <h2>Total: {{ votesTotal}}</h2>
                  <chartist ratio="ct-square" type="Pie" :data="chartData"></chartist>
                </div>
                <nav class="level">

                  <div class="level-item has-text-centered">
                    <div>
                      <p class="is-size-6">{{feedbackForm.thumbsupLabel}}</p>
                      <p class="title is-2 thumbup">{{ votesUp }}</p>
                      <p class="thumbup">{{ votesUpPercentage }}%</p>
                    </div>
                  </div>
                  <div v-if="feedbackForm.thumbsokLabel" class="level-item has-text-centered">
                    <div>
                      <p class="is-size-6">{{feedbackForm.thumbsokLabel}}</p>
                      <p class="title is-2 thumbok">{{ votesOk }}</p>
                      <p class="thumbok">{{ votesOkPercentage }}%</p>
                    </div>
                  </div>
                  <div v-if="feedbackForm.thumbsdownLabel" class="level-item has-text-centered">
                    <div>
                      <p class="is-size-6">{{feedbackForm.thumbsdownLabel}}</p>
                      <p class="title is-2 thumbdown">{{ votesDown }}</p>
                      <p class="thumbdown">{{ votesDownPercentage }}%</p>
                    </div>
                  </div>
                  <div v-if="feedbackForm.thumbsoption4" class="level-item has-text-centered">
                    <div>
                      <p class="is-size-6">{{feedbackForm.thumbsoption4Label}}</p>
                      <p class="title is-2 thumboption4">{{ votesOption4 }}</p>
                      <p class="thumboption4">{{ votesOption4Percentage }}%</p>
                    </div>
                  </div>
                  <div v-if="feedbackForm.thumbsoption5" class="level-item has-text-centered">
                    <div>
                      <p class="is-size-6">{{feedbackForm.thumbsoption5Label}}</p>
                      <p class="title is-2 thumboption5">{{ votesOption5 }}</p>
                      <p class="thumboption5">{{ votesOption5Percentage }}%</p>
                    </div>
                  </div>
                </nav>
                <div class="is-size-7	has-text-centered">
                  Stats are different than in your ESP? <a href="/faq#stats-differ-esp-fl">Click here to learn why</a>
                </div>
</div>
              <table class="table is-striped is-fullwidth mt-6">
                <thead>
                  <tr>
                    <th>Day</th>
                    <th>{{feedbackForm.thumbsupLabel}}</th>
                    <th v-if="feedbackForm.thumbsokLabel">{{feedbackForm.thumbsokLabel}}</th>
                    <th v-if="feedbackForm.thumbsdownLabel">{{feedbackForm.thumbsdownLabel}}</th>
                    <th v-if="feedbackForm.thumbsoption4">{{feedbackForm.thumbsoption4Label}}</th>
                    <th v-if="feedbackForm.thumbsoption5">{{feedbackForm.thumbsoption5Label}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(votes) in feedbackForm.dailyVotes" v-bind:key="votes.date">
                    <td>{{votes.date}}</td>
                    <td>{{votes.up_votes || 0}}</td>
                    <td v-if="feedbackForm.thumbsokLabel">{{votes.ok_votes || 0}}</td>
                    <td v-if="feedbackForm.thumbsdownLabel">{{votes.down_votes || 0}}</td>
                    <td v-if="feedbackForm.thumbsoption4">{{votes.option4_votes || 0}}</td>
                    <td v-if="feedbackForm.thumbsoption5">{{votes.option5_votes || 0}}</td>
                  </tr>
                </tbody>
              </table>
              <div v-if="!feedbackForm.dailyVotes">
                No votes or votes before daily votes feature went live.
              </div>
            </div>
            <div class="column is-half">
              <h2 class="mb-2">Comments ({{allReasons.length}})</h2>
              <div class="mb-6">
                <div class="field has-addons has-addons-centered ">
                      <div class="select is-small">
                        <select v-model="commentFilterScore">
                          <option value="all">All</option>
                          <option value="1">{{feedbackForm.thumbsupLabel}} only</option>
                          <option value="2">{{feedbackForm.thumbsokLabel}} only</option>
                          <option value="3">{{feedbackForm.thumbsdownLabel}} only</option>
                          <option v-if="feedbackForm.thumbsoption4" value="4">{{feedbackForm.thumbsoption4Label}} only</option>
                          <option v-if="feedbackForm.thumbsoption5" value="5">{{feedbackForm.thumbsoption5Label}} only</option>
                        </select>
                      </div>
                  <p class="control">
                    <input class="input is-small" type="text" v-model="commentFilterReason" placeholder="Words in comment" v-on:keyup.enter="filterComments">
                  </p>
                  <p class="control">
                    <a class="button is-primary is-small" @click="filterComments">
                      Filter
                    </a>
                  </p>
                </div>
              </div>

              <p v-if="reasons.length === 0">
                No extended feedback reported by your readers.
              </p>
              <div v-if="reasonsPages > 1" class="my-2">
                <b-pagination
                  :total="allFilteredReasons.length"
                  v-model="reasonsCurrentPage"
                  :simple="true"
                  size="is-small"
                  :per-page="reasonsPerPage"
                  icon-prev="ChevronLeft"
                  icon-next="ChevronRight"
                  aria-next-label="Next page"
                  aria-previous-label="Previous page"
                  aria-page-label="Page"
                  aria-current-label="Current page"
                  @change="reasonsCurrentPageChanged"
                />
              </div>
              <div class="mb-4" v-for="r in reasons" v-bind:key="r.id">
                <FeedbackReasonCard :reason="r" :subscribed="account.subscribed" :user="user" v-on:feedback-deleted="feedbackDeleted"/>
              </div>
              <div v-if="reasonsPages > 1" class="my-2">
                <b-pagination
                  :total="allFilteredReasons.length"
                  v-model="reasonsCurrentPage"
                  :simple="true"
                  size="is-small"
                  :per-page="reasonsPerPage"
                  icon-prev="ChevronLeft"
                  icon-next="ChevronRight"
                  aria-next-label="Next page"
                  aria-previous-label="Previous page"
                  aria-page-label="Page"
                  aria-current-label="Current page"
                  @change="reasonsCurrentPageChanged"
                />
              </div>

            </div>
          </div>
        </div>
        <div v-if="activeTab == 1">
          <div class="columns">
            <div class="column">
              <div class="field">
                <label class="label" for="name"
                  >Form Name (Required - Internal use)</label
                >
                <div class="control">
                  <input
                    v-model="feedbackForm.formName"
                    id="formName"
                    name="formName"
                    type="text"
                    placeholder="Name of the survey/poll"
                    class="input"
                    required
                  />
                </div>
              </div>
              <div v-if="!isWebRating" class="field mb-6">
                <label class="label" for="name">Your Name (Public)</label>
                <div class="control">
                  <input
                    v-model="feedbackForm.name"
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Your name that can be used in a placeholder on the extended feedback page"
                    class="input"
                    required
                  />
                </div>
                <p class="help">
                  The name you enter will be used on the extended feedback page as the NAME placeholder with the default texts. Enter a name your readers recognize, e.g. 
                      your name or the name of your newsletter.
                </p>
              </div>
              <WebRatingCustomizationSection v-if="isWebRating" :feedbackForm="feedbackForm"
                />
              <FormCustomSection v-else
                :feedbackForm="feedbackForm"
              />
              <div class="field is-grouped">
                <div class="control">
                  <button
                    :disabled="!saveBtnEnabled"
                    v-bind:class="{ 'is-loading': isSaving }"
                    class="button is-primary is-outlined"
                    @click.prevent="save"
                  >
                    Save
                  </button>
                </div>
                <div class="control">
                  <button
                    v-bind:class="{ 'is-loading': isSaving }"
                    class="button is-warning is-outlined"
                    @click.prevent="confirmReset"
                  >
                    Reset Analytics
                  </button>
                </div>
                <div class="control">
                  <button
                    v-bind:class="{ 'is-loading': isSaving }"
                    class="button is-danger is-outlined"
                    @click.prevent="confirmDelete"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="activeTab == 2">
          <template v-if="!isWebRating">
            <h2 class="subtitle">
              Copy a block and paste it into you email.
            </h2>
            <div class="columns mt-4">
              <div class="column is-half">
            <div class="field">
              <label class="label">Add an Email MergeTag to the voting links.</label>
              <div class="control">
                  <div class="select">
                    <select v-model="emailProvider" @change="addEmailPreset">
                      <option value="none">none</option>
                      <option value="emailoctopus">Email Octopus</option>
                      <option value="mailchimp">Mailchimp</option>
                      <option value="mailerlite">MailerLite</option>
                      <option value="convertkit">ConvertKit</option>
                      <option value="buttondown">Buttondown</option>
                      
                    </select>
                  </div>
              </div>
              <p class="help">
                The readers's email address is only used as a preset for the email input on the Extended Feedback Page. It is not used for anything else. Votes are not associated with it.
              </p>
            </div>
              </div>
            </div>

            <div class="columns mt-4">
              <div class="column is-half">
                <h2 class="subtitle">Theme Bullets</h2>
                <p class="has-text-right">
                  <a
                    class="button is-small"
                    @click.prevent="copyAsTextReg"
                    v-bind:class="{ 'has-text-success': copiedText }"
                    >{{ copyAsTextButton }}</a
                  >
                  <a
                    class="button is-small"
                    @click.prevent="copyAsHtmlReg"
                    v-bind:class="{ 'has-text-success': copiedHtml }"
                    >{{ copyAsHtmlButton }}</a
                  >
                </p>
                <textarea id="formWidgetHtml"></textarea>
                <div id="formWidget" class="content is-medium box">
                  <p>
                    <strong>{{ feedbackForm.thumbsHeadline }}</strong>
                  </p>

                  <p>{{ feedbackForm.thumbsParagraph }}</p>

                  <ul>
                    <li>
                      <a
                        :href="'https://a.feedletter.co/s/' + formId + '/1' + votingLinkEmailSuffix"
                        target="_blank"
                        >{{ feedbackForm.thumbsup }}</a
                      >
                    </li>
                    <li v-if="isNewsletter || feedbackForm.thumbsok">
                      <a
                        :href="'https://a.feedletter.co/s/' + formId + '/2' + votingLinkEmailSuffix"
                        target="_blank"
                        >{{ feedbackForm.thumbsok }}</a
                      >
                    </li>
                    <li v-if="isNewsletter || feedbackForm.thumbsdown">
                      <a
                        :href="'https://a.feedletter.co/s/' + formId + '/3' + votingLinkEmailSuffix"
                        target="_blank"
                        >{{ feedbackForm.thumbsdown }}</a
                      >
                    </li>
                    <li v-if="feedbackForm.thumbsoption4">
                      <a
                        :href="'https://a.feedletter.co/s/' + formId + '/4' + votingLinkEmailSuffix"
                        target="_blank"
                        >{{ feedbackForm.thumbsoption4 }}</a
                      >
                    </li>
                    <li v-if="feedbackForm.thumbsoption5">
                      <a
                        :href="'https://a.feedletter.co/s/' + formId + '/5' + votingLinkEmailSuffix"
                        target="_blank"
                        >{{ feedbackForm.thumbsoption5 }}</a
                      >
                    </li>
                  </ul>

                  <p v-if="!account.subscribed">
                    Build your own? 👉 <a href="https://feedletter.co?nlb" target="_blank" rel="noopener">FeedLetter.co</a>
                  </p>
                </div>

                <template v-if="!isNewsletter">
                <p class="has-text-right">

                  <a
                    class="button is-small"
                    @click.prevent="copyAsJS"
                    v-bind:class="{ 'has-text-success': copiedJS }"
                    >{{ copyAsJSButton }}</a
                  >
                </p>
                <div class="content is-small box ">
                  <router-link
                  v-if="!account.subscribed"
                    :to="{ name: 'Upgrade' }"
                    class="tag is-info"
                    >Unlock Rich Snippet Support</router-link
                  >
                  <textarea id="formWidgetJS">
                &lt;script type="text/javascript" defer src="https://feedletter.co/feedback/widget/{{formId}}"&gt;&lt;/script&gt;
                  </textarea>
                  <p><pre>&lt;script type="text/javascript" defer src="https://feedletter.co/feedback/widget/{{formId}}"&gt;&lt;/script&gt;

    // add script tag before body close</pre></p>

                    <h2 class="subtitle mt-6">Hosted Survey Entry with Voting
                  <span
                  class="tag is-warning"
                  >NEW</span
                ></h2>
                <p class="has-text-right">
                  <a
                    class="button is-small"
                    @click.prevent="copyAsTextHosted"
                    v-bind:class="{ 'has-text-success': copiedTextHosted }"
                    >{{ copyAsTextButtonHosted }}</a
                  >
                </p>
                <div class="field">
                  <div class="control">
                    <input
                      id="formWidgetHosted"
                      type="text"
                      class="input"
                      :value="'https://a.feedletter.co/s/'+ formId + votingLinkEmailSuffix"
                      readonly
                    />
                  </div>
                </div>
                </div>
                </template>



              </div>
              <div class="column is-half">
                <h2 class="subtitle">Theme Inline</h2>
                <p class="has-text-right">
                  <a
                    class="button is-small"
                    @click.prevent="copyAsTextAlt"
                    v-bind:class="{ 'has-text-success': copiedTextAlt }"
                    >{{ copyAsTextButtonAlt }}</a
                  >
                  <a
                    class="button is-small"
                    @click.prevent="copyAsHtmlAlt"
                    v-bind:class="{ 'has-text-success': copiedHtmlAlt }"
                    >{{ copyAsHtmlButtonAlt }}</a
                  >
                </p>
                <textarea id="formWidgetHtmlAlt"></textarea>
                <div id="formWidgetAlt" class="content is-medium box">
                  <p>
                    <strong>{{ feedbackForm.thumbsHeadline }}</strong>
                  </p>

                  <p>{{ feedbackForm.thumbsParagraph }}</p>


                    <p>
                      <a
                        :href="'https://a.feedletter.co/s/' + formId + '/1' + votingLinkEmailSuffix"
                        target="_blank"
                        >{{ feedbackForm.thumbsup }}</a
                      >
                      <template  v-if="isNewsletter || feedbackForm.thumbsok">
  - 
                      <a
                        :href="'https://a.feedletter.co/s/' + formId + '/2' + votingLinkEmailSuffix"
                        target="_blank"
                        >{{ feedbackForm.thumbsok }}</a
                      >
                      </template>
                      <template  v-if="isNewsletter || feedbackForm.thumbsdown">
  - 
                      <a
                        :href="'https://a.feedletter.co/s/' + formId + '/3' + votingLinkEmailSuffix"
                        target="_blank"
                        >{{ feedbackForm.thumbsdown }}</a
                      >
                      </template>
                      <template v-if="feedbackForm.thumbsoption4">
  - 
                      <a
                        :href="'https://a.feedletter.co/s/' + formId + '/4' + votingLinkEmailSuffix"
                        target="_blank"
                        >{{ feedbackForm.thumbsoption4 }}</a
                      >
                      </template>
                      <template v-if="feedbackForm.thumbsoption5">
  - 
                      <a
                        :href="'https://a.feedletter.co/s/' + formId + '/5' + votingLinkEmailSuffix"
                        target="_blank"
                        >{{ feedbackForm.thumbsoption5 }}</a
                      >
                      </template>
                    </p>
                    <p v-if="!account.subscribed">Build your own? 👉 <a href="https://feedletter.co?nlb" target="_blank" rel="noopener">FeedLetter.co</a>
                    </p>
                </div>


              </div>
            </div>
          </template>
          <template v-else>
            <h2 class="subtitle">
              Copy a block and paste it into your html page.
            </h2>
            <div class="columns">
              <div class="column is-half">
                <h2 class="subtitle">Time Triggered Popup</h2>
                <p>Shows the widget in the bottom left corner. Time configured on Advanced tab under Edit.</p>
                <p class="has-text-right">

                  <a
                    class="button is-small"
                    @click.prevent="copyAsJS"
                    v-bind:class="{ 'has-text-success': copiedJS }"
                    >{{ copyAsJSButton }}</a
                  >
                </p>
                <div class="content is-small box ">
                  <textarea id="formWidgetJS">
                    &lt;script&gt; var feedletterFormId ='{{ formId}}' &lt;/script&gt;
                &lt;script type="text/javascript" defer src="https://feedletter.co/embed/widget.js"&gt;&lt;/script&gt;
                  </textarea>
                  <p><pre>&lt;script&gt; var feedletterFormId ='{{ formId}}' &lt;/script&gt;
&lt;script type="text/javascript" defer src="https://feedletter.co/embed/widget.js"&gt;&lt;/script&gt;

// add script tag before body close</pre></p>
                </div>

                <h2 class="subtitle">Inline Widget</h2>
                <p>Shows the widget inline the content. Paste the code at the position where the widget should appear.</p>
                <p class="has-text-right">

                  <a
                    class="button is-small"
                    @click.prevent="copyAsJSInline"
                    v-bind:class="{ 'has-text-success': copiedJSInline }"
                    >{{ copyAsJSButtonInline }}</a
                  >
                </p>
                <div class="content is-small box ">
                  <textarea id="formWidgetJSInline">
                    &lt;div id="feedletter-widget"&gt;&lt;/div&gt;
                    &lt;script&gt; var feedletterFormId ='{{ formId}}' &lt;/script&gt;
                &lt;script type="text/javascript" defer src="https://feedletter.co/embed/widget.js"&gt;&lt;/script&gt;
                  </textarea>
                  <p><pre>&lt;div id="feedletter-widget"&gt;&lt;/div&gt;
&lt;script&gt; var feedletterFormId ='{{ formId}}' &lt;/script&gt;
&lt;script type="text/javascript" defer src="https://feedletter.co/embed/widget.js"&gt;&lt;/script&gt;
</pre></p>
                </div>
                <p>For advanced configuration, please read <a href="/webrating-advanced/" target="_blank">this help page</a>.
                </p>
              </div>
              <div class="column is-half">
                <h2 class="subtitle">Feedback Button</h2>
                <p>Displays a Feedback button at the center right of the screen. Opens the widget by clicking on the button</p>
                <p class="has-text-right">

                  <a
                    class="button is-small"
                    @click.prevent="copyAsJSFB"
                    v-bind:class="{ 'has-text-success': copiedJSFB }"
                    >{{ copyAsJSButtonFB }}</a
                  >
                </p>
                <div class="content is-small box ">
                  <textarea id="formWidgetJSFB">
                    &lt;button id="feedletter-widget-button"&gt;Feedback&lt;/button&gt;
                    &lt;script&gt; var feedletterFormId ='{{ formId}}' &lt;/script&gt;
                &lt;script type="text/javascript" defer src="https://feedletter.co/embed/widget.js"&gt;&lt;/script&gt;
                  </textarea>
                  <p><pre>&lt;button id="feedletter-widget-button"&gt;Feedback&lt;/button&gt;
&lt;script&gt; var feedletterFormId ='{{ formId}}' &lt;/script&gt;
&lt;script type="text/javascript" defer src="https://feedletter.co/embed/widget.js"&gt;&lt;/script&gt;
</pre></p>
                </div>
              </div>
            </div>
          </template>
        </div>
        
</div>
      </div>
    </section>
  </div>
</template>

<script>
// @ is an alias to /src
import atomic from "atomicjs";
import FeedbackReasonCard from "@/components/FeedbackReasonCard.vue";
import FormCustomSection from "@/components/FormCustomizationSection.vue";
import WebRatingCustomizationSection from "@/components/WebRatingCustomizationSection.vue";
import { mapState } from "vuex";
import {trackEvent}  from "../lib/flevents"

export default {
  name: "FeedbackView",
  components: {
    FormCustomSection,
    WebRatingCustomizationSection,
    FeedbackReasonCard,
  },
  data: function () {
    return {
      activeTab: 0,
      copiedText: false,
      copyAsTextButton: "Copy",
      copiedTextHosted: false,
      copyAsTextButtonHosted: "Copy",
      copiedHtml: false,
      copyAsHtmlButton: "Copy as HTML",
      copiedTextAlt: false,
      copyAsTextButtonAlt: "Copy",
      copiedHtmlAlt: false,
      copyAsHtmlButtonAlt: "Copy as HTML",
      copiedJS: false,
      copyAsJSButton: "Copy as Web Widget",
      copiedJSInline: false,
      copyAsJSButtonInline: "Copy as Inline Widget",
      copiedJSFB: false,
      copyAsJSButtonFB: "Copy as Feedback Button",
      showCreatedMsg: true,
      formId: null,
      saveBtnEnabled: false,
      loading: false,
      isSaving: false,
      feedbackForm: {
        formName: null,
        name: null,
        thumbsup: "👍 That helped me. Thanks",
        thumbsok: "😐 Meh - was ok.",
        thumbsdown: "👎 Not interesting to me.",
        thumbsHeadline: "Was it useful? Help us to improve!",
        thumbsParagraph:
          "With your feedback, we can improve the letter. Click on a link to vote:",

        efpThumbsupReasonHeader: "👍 you did enjoy NAME email 👍",
        efpThumbsokReasonHeader:
          "😐 you are not sure what to think about NAME email 😐",
        efpThumbsdownReasonHeader: "👎 you didn’t enjoy NAME email 👎",
        efpThankYouText: "Thank you. Your feedback was successfully shared.",
        efpWhyBoxText: "Why",
        efpWhyBoxPlaceholder: "Listen to your gut :-)",
        efpButtonText: "Send your message",
        efpReaderNamePlaceholder:
          "Enter your name or leave it blank to stay anonymous",
        efpReaderEmailPlaceholder:
          "Enter your email if you want a reply from me",
        efpTextMsgText: "write a text message instead",
        efpVoiceText: "or leave a voice message",
        efpAllowAudioFeedback: "1",
        efpVoiceRemainingText: "Record duration is limited",
        efpNotificationEmail: null,
        efpNotificationWebhookURL: null,
        typHeadline: "Thank you for sharing your thoughts",
        typSubHeadline: "We wish you a wonderful day and stay safe!",
        typRedirect: null,
        typShareButtonTwitter: "Share your feedback on Twitter",
        typShareTwitterHandle: null,
        thumbsupLabel: "",
        thumbsokLabel: "",
        thumbsdownLabel: "",
        thumbsoption4: null,
        efpThumbsoption4ReasonHeader: null,
        thumbsoption5: null,
        efpThumbsoption5ReasonHeader: null,
        dailyVotes: {},
        formType: "newsletter",
        webRatingType: "thumbs",
        wrEnableReviewSchema: "0",
        wrShowBranding: "1",
        showBranding: "1",
        wrShowWidgetTime: "10",
        efpEnabled: "1",
        efpAllowBlankFeedback: "0",
        wrEmailMandatory: "0",
        efpPrefillEmail: "1",
      },
      votesUp: 0,
      votesOk: 0,
      votesDown: 0,
      votesOption4: 0,
      votesOption5: 0,
      votesTotal: 0,
      reasons: [], //to show
      allFilteredReasons: [],
      allReasons: [],
      reasonsPages: 1,
      reasonsCurrentPage: 1,
      reasonsPerPage: 100,
      chartData: null,
      emailProvider: "none",
      votingLinkEmailSuffix: "",
      commentFilterScore: "all",
      commentFilterReason: ""

    };
  },

  mounted: function () {
    if (!this.user.isLoggedIn) {
      this.$router.push("/login");
      return;
    }

    if (this.$route.query.created) {
      this.activeTab = 2;
    }
    this.formId = this.$route.params.formId;
    this.load();
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    trackEvent(this.$store.state.user.id, "survey-edit-view")
  },
  methods: {
    addEmailPreset: function() {
      if(this.emailProvider == "emailoctopus") {
          this.votingLinkEmailSuffix = "?e={{EmailAddress}}"
      } else if (this.emailProvider == "mailchimp") {
        this.votingLinkEmailSuffix = "?e=*|EMAIL|*"
      } else if (this.emailProvider == "mailerlite") {
        this.votingLinkEmailSuffix = "?e={$email}"
      } else if (this.emailProvider == "convertkit") {
        this.votingLinkEmailSuffix = "?e={{ subscriber.email_address }}"
      } else if (this.emailProvider == "buttondown") {
        this.votingLinkEmailSuffix = "?e={{ subscriber.email }}"
      } else {
        this.votingLinkEmailSuffix = ""
      }
    },
    copyAsText: function (elemId) {
      let formWidgetToCopy = document.getElementById(elemId);
      var range = document.createRange();
      range.selectNodeContents(formWidgetToCopy);
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(range);
      document.execCommand("copy");
      /* unselect the range */
      window.getSelection().removeAllRanges();
    },
    copyAsTextAlt: function () {
      try {
        this.copyAsText("formWidgetAlt");
        this.copiedTextAlt = true;
        this.copyAsTextButtonAlt = "Copied";

        trackEvent(this.$store.state.user.id, "survey-edit-maintab-copyalt")
      } catch (err) {
        alert("Unable to copy");
      }
    },
    copyAsTextReg: function () {
      try {
        this.copyAsText("formWidget");
        this.copiedText = true;
        this.copyAsTextButton = "Copied";
        
        trackEvent(this.$store.state.user.id, "survey-edit-maintab-copyreg")
      } catch (err) {
        alert("Unable to copy");
      }
    },
    copyAsTextHosted: function () {
      try {
        let e = document.getElementById("formWidgetHosted");
        console.log("e=", e);
        e.select();
        document.execCommand("copy");
        this.copiedTextHosted = true;
        this.copyAsTextButtonHosted = "Copied";
        trackEvent(this.$store.state.user.id, "survey-edit-maintab-copyhosted")
      } catch (err) {
        alert("Unable to copy" + err);
      }
    },
    copyAsHtml: function (elemSelector, textareaId) {
      let formWidgetHtmlIn = document.querySelector(elemSelector).innerHTML;
      let formWidgetHtml = document.getElementById(textareaId);
      formWidgetHtml.value = formWidgetHtmlIn;
      formWidgetHtml.select();
      document.execCommand("copy");
      /* unselect the range */
      window.getSelection().removeAllRanges();
    },
    copyAsHtmlReg: function () {
      try {
        this.copyAsHtml("#formWidget", "formWidgetHtml");
        this.copiedHtml = true;
        this.copyAsHtmlButton = "Copied as HTML";
        trackEvent(this.$store.state.user.id, "survey-edit-maintab-copyhtmlreg")
      } catch (err) {
        alert("Unable to copy");
      }
    },
    copyAsHtmlAlt: function () {
      try {
        this.copyAsHtml("#formWidgetAlt", "formWidgetHtmlAlt");
        this.copiedHtmlAlt = true;
        this.copyAsHtmlButtonAlt = "Copied as HTML";
        trackEvent(this.$store.state.user.id, "survey-edit-maintab-copyhtmlalt")
      } catch (err) {
        alert("Unable to copy");
      }
    },
    copyAsJS: function () {
      let formWidgetJS = document.getElementById("formWidgetJS");
      formWidgetJS.select();

      try {
        document.execCommand("copy");
        this.copiedJS = true;
        this.copyAsJSButton = "Copied as Web Widget";
      } catch (err) {
        alert("Unable to copy");
      }

      /* unselect the range */
      window.getSelection().removeAllRanges();
      trackEvent(this.$store.state.user.id, "survey-edit-maintab-copyjs")
    },
    copyAsJSInline: function () {
      let formWidgetJS = document.getElementById("formWidgetJSInline");
      formWidgetJS.select();

      try {
        document.execCommand("copy");
        this.copiedJSInline = true;
        this.copyAsJSButtonInline = "Copied as Inline Widget";
      } catch (err) {
        alert("Unable to copy");
      }

      /* unselect the range */
      window.getSelection().removeAllRanges();

      trackEvent(this.$store.state.user.id, "survey-edit-maintab-copyjs-inline")
    },
    copyAsJSFB: function () {
      let formWidgetJS = document.getElementById("formWidgetJSFB");
      formWidgetJS.select();

      try {
        document.execCommand("copy");
        this.copiedJSFB = true;
        this.copyAsJSButtonFB = "Copied as Feedback Button";
      } catch (err) {
        alert("Unable to copy");
      }

      /* unselect the range */
      window.getSelection().removeAllRanges();
      trackEvent(this.$store.state.user.id, "survey-edit-maintab-copyjs-fb")
    },
    load: async function () {
      var self = this;
      this.$store
        .dispatch("getAPIToken")
        .then((token) => {
          self.loading = true;
          atomic(self.apiHost + "feedforms/" + self.formId, {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-type": "application/json",
            },
          })
            .then(function (response) {
              self.updateData(self, response);
              
              let tempReasons = response.data.reasons || [];
              self.reasonsPages = Math.ceil(tempReasons.length / self.reasonsPerPage)
              self.reasons = tempReasons.slice(0, self.reasonsPerPage);
              self.allReasons = tempReasons;
              self.allFilteredReasons = tempReasons;

              var labels = [
                self.feedbackForm.thumbsupLabel,
                self.feedbackForm.thumbsokLabel,
                self.feedbackForm.thumbsdownLabel,
              ];
              var series = [self.votesUp, self.votesOk, self.votesDown];

              if (
                self.feedbackForm.thumbsoption4 !== undefined &&
                self.feedbackForm.thumbsoption4 !== null
              ) {
                labels.push(self.feedbackForm.thumbsoption4Label);
                series.push(self.votesOption4);
              }
              if (
                self.feedbackForm.thumbsoption5 !== undefined &&
                self.feedbackForm.thumbsoption5 !== null
              ) {
                labels.push(self.feedbackForm.thumbsoption5Label);
                series.push(self.votesOption5);
              }
              self.chartData = {
                labels: labels,
                series: series,
              };
              //console.log(response.data); // xhr.responseText
              //console.log(response.xhr); // full response
            })
            .catch(function (error) {
              self.loading = false;
              console.log(error.status); // xhr.status
              console.log(error.statusText); // xhr.statusText
            });
        })
        .catch((error) => {
          this.$parent.$emit("unauthed");
        });
    },
    updateData: function (self, response) {
      self.feedbackForm.formId = self.formId;
      self.feedbackForm.formType = response.data.form_type;
      self.feedbackForm.webRatingType = response.data.config.webRatingType;
      self.feedbackForm.wrEnableReviewSchema =
        response.data.config.wrEnableReviewSchema || "0";
      self.feedbackForm.wrShowWidgetTime =
        response.data.config.wrShowWidgetTime || "10";

      self.feedbackForm.wrShowBranding =
        response.data.config.wrShowBranding || "1";
      
      self.feedbackForm.wrEmailMandatory =
        response.data.config.wrEmailMandatory || "0";

      self.feedbackForm.showBranding = response.data.config.showBranding || "1";

      self.feedbackForm.efpEnabled = response.data.config.efpEnabled || "1";
      self.feedbackForm.efpAllowBlankFeedback = response.data.config.efpAllowBlankFeedback || "0";
      self.feedbackForm.efpPrefillEmail = response.data.config.efpPrefillEmail || "1";

      self.feedbackForm.formName = response.data.name;
      self.feedbackForm.name = response.data.config.name;
      self.feedbackForm.thumbsup =
        response.data.config.thumbsupText || response.data.up_label;
      self.feedbackForm.thumbsok =
        response.data.config.thumbsokText || response.data.ok_label;
      self.feedbackForm.thumbsdown =
        response.data.config.thumbsdownText || response.data.down_label;
      self.feedbackForm.thumbsoption4 =
        response.data.config.thumbsoption4Text || response.data.option4_label;
      self.feedbackForm.thumbsoption5 =
        response.data.config.thumbsoption5Text || response.data.option5_label;

      self.feedbackForm.dailyVotes = response.data.daily_votes;
      if (response.data.config.thumbsHeadline !== undefined) {
        self.feedbackForm.thumbsHeadline = response.data.config.thumbsHeadline;
      }
      if (response.data.config.thumbsParagraph !== undefined) {
        self.feedbackForm.thumbsParagraph =
          response.data.config.thumbsParagraph;
      }
      if (
        response.data.config.thumbsupReasonHeader !== undefined ||
        response.data.config.efpThumbsupReasonHeader !== undefined
      ) {
        self.feedbackForm.efpThumbsupReasonHeader =
          response.data.config.thumbsupReasonHeader ||
          response.data.config.efpThumbsupReasonHeader;
      } else {
        self.feedbackForm.efpThumbsupReasonHeader =
          self.feedbackForm.efpThumbsupReasonHeader;
      }
      if (
        response.data.config.thumbsokReasonHeader !== undefined ||
        response.data.config.efpThumbsokReasonHeader !== undefined
      ) {
        self.feedbackForm.efpThumbsokReasonHeader =
          response.data.config.thumbsokReasonHeader ||
          response.data.config.efpThumbsokReasonHeader;
      } else {
        self.feedbackForm.efpThumbsokReasonHeader =
          self.feedbackForm.efpThumbsokReasonHeader;
      }
      if (
        response.data.config.thumbsdownReasonHeader !== undefined ||
        response.data.config.efpThumbsdownReasonHeader !== undefined
      ) {
        self.feedbackForm.efpThumbsdownReasonHeader =
          response.data.config.thumbsdownReasonHeader ||
          response.data.config.efpThumbsdownReasonHeader;
      } else {
        self.feedbackForm.efpThumbsdownReasonHeader =
          self.feedbackForm.efpThumbsdownReasonHeader;
      }
      if (
        response.data.config.thumbsoption4ReasonHeader !== undefined ||
        response.data.config.efpThumbsoption4ReasonHeader !== undefined
      ) {
        self.feedbackForm.efpThumbsoption4ReasonHeader =
          response.data.config.thumbsoption4ReasonHeader ||
          response.data.config.efpThumbsoption4ReasonHeader;
      }
      if (
        response.data.config.thumbsoption5ReasonHeader !== undefined ||
        response.data.config.efpThumbsoption5ReasonHeader !== undefined
      ) {
        self.feedbackForm.efpThumbsoption5ReasonHeader =
          response.data.config.thumbsoption5ReasonHeader ||
          response.data.config.efpThumbsoption5ReasonHeader;
      }
      if (response.data.config.efpThankYouText !== undefined) {
        self.feedbackForm.efpThankYouText =
          response.data.config.efpThankYouText;
      }
      if (response.data.config.efpWhyBoxText !== undefined) {
        self.feedbackForm.efpWhyBoxText = response.data.config.efpWhyBoxText;
      }
      if (response.data.config.efpWhyBoxPlaceholder !== undefined) {
        self.feedbackForm.efpWhyBoxPlaceholder =
          response.data.config.efpWhyBoxPlaceholder;
      }
      if (response.data.config.efpButtonText !== undefined) {
        self.feedbackForm.efpButtonText = response.data.config.efpButtonText;
      }
      if (response.data.config.efpReaderNamePlaceholder !== undefined) {
        self.feedbackForm.efpReaderNamePlaceholder =
          response.data.config.efpReaderNamePlaceholder;
      } else {
        self.feedbackForm.efpReaderNamePlaceholder = null;
      }

      if (response.data.config.efpReaderEmailPlaceholder !== undefined) {
        self.feedbackForm.efpReaderEmailPlaceholder =
          response.data.config.efpReaderEmailPlaceholder;
      } else {
        self.feedbackForm.efpReaderEmailPlaceholder = null;
      }

      if (response.data.config.efpTextMsgText !== undefined) {
        self.feedbackForm.efpTextMsgText = response.data.config.efpTextMsgText;
      }

      if (response.data.config.efpVoiceText !== undefined) {
        self.feedbackForm.efpVoiceText = response.data.config.efpVoiceText;
      }
      if (response.data.config.efpAllowAudioFeedback !== undefined) {
        self.feedbackForm.efpAllowAudioFeedback =
          response.data.config.efpAllowAudioFeedback;
      }

      if (response.data.config.efpVoiceRemainingText !== undefined) {
        self.feedbackForm.efpVoiceRemainingText =
          response.data.config.efpVoiceRemainingText;
      }

      if (response.data.config.efpNotificationEmail !== undefined) {
        self.feedbackForm.efpNotificationEmail =
          response.data.config.efpNotificationEmail;
      }
      if (response.data.config.efpNotificationWebhookURL !== undefined) {
        self.feedbackForm.efpNotificationWebhookURL =
          response.data.config.efpNotificationWebhookURL;
      }

      if (response.data.config.typHeadline !== undefined) {
        self.feedbackForm.typHeadline = response.data.config.typHeadline;
      }
      if (response.data.config.typSubHeadline !== undefined) {
        self.feedbackForm.typSubHeadline = response.data.config.typSubHeadline;
      }
      if (response.data.config.typRedirect !== undefined) {
        self.feedbackForm.typRedirect = response.data.config.typRedirect;
      }
      if (response.data.config.typShareTwitterHandle !== undefined) {
        self.feedbackForm.typShareTwitterHandle =
          response.data.config.typShareTwitterHandle;
      }
      if (response.data.config.typShareButtonTwitter !== undefined) {
        self.feedbackForm.typShareButtonTwitter =
          response.data.config.typShareButtonTwitter;
      }

      self.feedbackForm.thumbsupLabel = response.data.up_label_short;
      self.feedbackForm.thumbsokLabel = response.data.ok_label_short;
      self.feedbackForm.thumbsdownLabel = response.data.down_label_short;
      self.feedbackForm.thumbsoption4Label = response.data.option4_label_short;
      self.feedbackForm.thumbsoption5Label = response.data.option5_label_short;
      self.votesUp = response.data.up_votes || 0;
      self.votesOk = response.data.ok_votes || 0;
      self.votesDown = response.data.down_votes || 0;
      self.votesOption4 = response.data.option4_votes || 0;
      self.votesOption5 = response.data.option5_votes || 0;
      self.votesTotal =
        self.votesUp +
        self.votesOk +
        self.votesDown +
        self.votesOption4 +
        self.votesOption5;
    },
    save: async function () {
      trackEvent(this.$store.state.user.id, "survey-edit-view-save")
      this.isSaving = true;
      var feedbackFormSend = {
        name: this.feedbackForm.formName,
        form_type: this.feedbackForm.formType,
        up_label: this.feedbackForm.thumbsup,
        ok_label: this.feedbackForm.thumbsok,
        down_label: this.feedbackForm.thumbsdown,
        option4_label: this.isEmptyOrSpaces(this.feedbackForm.thumbsoption4)
          ? null
          : this.feedbackForm.thumbsoption4,
        option5_label: this.isEmptyOrSpaces(this.feedbackForm.thumbsoption5)
          ? null
          : this.feedbackForm.thumbsoption5,
      };
      if (this.isWebRating) {
        // ATTENTION: keep setting vote text to null as ongoing migration
        feedbackFormSend.config = {
          thumbsupText: null,
          thumbsokText: null,
          thumbsdownText: null,
          thumbsHeadline: this.feedbackForm.thumbsHeadline,
          thumbsoption4Text: null,
          thumbsoption5Text: null,
          efpThumbsupReasonHeader: this.feedbackForm.efpThumbsupReasonHeader,
          efpThumbsokReasonHeader: this.feedbackForm.efpThumbsokReasonHeader,
          efpThumbsdownReasonHeader:
            this.feedbackForm.efpThumbsdownReasonHeader,
          efpThumbsoption4ReasonHeader:
            this.feedbackForm.efpThumbsoption4ReasonHeader,
          efpThumbsoption5ReasonHeader:
            this.feedbackForm.efpThumbsoption5ReasonHeader,
          efpReaderEmailPlaceholder: this.feedbackForm.efpReaderEmailPlaceholder,
          efpReaderNamePlaceholder: this.feedbackForm.efpReaderNamePlaceholder,
          wrEnableReviewSchema: this.feedbackForm.wrEnableReviewSchema,
          wrShowWidgetTime: this.feedbackForm.wrShowWidgetTime,
          wrShowBranding: this.feedbackForm.wrShowBranding,
          wrEmailMandatory: this.feedbackForm.wrEmailMandatory,
          efpButtonText: this.feedbackForm.efpButtonText,
          typHeadline: this.feedbackForm.typHeadline,

          user_id: this.$parent.user.id,

          efpNotificationEmail: this.feedbackForm.efpNotificationEmail,
          efpNotificationWebhookURL:
            this.feedbackForm.efpNotificationWebhookURL,

          webRatingType: this.feedbackForm.webRatingType,
        };
      } else {
        feedbackFormSend.config = {
          name: this.feedbackForm.name,
          thumbsupText: null,
          thumbsokText: null,
          thumbsdownText: null,
          thumbsHeadline: this.feedbackForm.thumbsHeadline,
          thumbsParagraph: this.feedbackForm.thumbsParagraph,
          thumbsoption4Text: null,
          thumbsoption5Text: null,
          efpThumbsoption4ReasonHeader:
            this.feedbackForm.efpThumbsoption4ReasonHeader,
          efpThumbsoption5ReasonHeader:
            this.feedbackForm.efpThumbsoption5ReasonHeader,

          efpThankYouText: this.feedbackForm.efpThankYouText,
          efpWhyBoxText: this.feedbackForm.efpWhyBoxText,
          efpWhyBoxPlaceholder: this.feedbackForm.efpWhyBoxPlaceholder,
          efpButtonText: this.feedbackForm.efpButtonText,
          typHeadline: this.feedbackForm.typHeadline,
          typSubHeadline: this.feedbackForm.typSubHeadline,
          user_id: this.$parent.user.id,
          efpThumbsupReasonHeader:
            this.feedbackForm.efpThumbsupReasonHeader,
          efpThumbsokReasonHeader:
            this.feedbackForm.efpThumbsokReasonHeader,
          efpThumbsdownReasonHeader:
            this.feedbackForm.efpThumbsdownReasonHeader,

          typRedirect: this.feedbackForm.typRedirect,
          typShareTwitterHandle: this.feedbackForm.typShareTwitterHandle,
          typShareButtonTwitter: this.feedbackForm.typShareButtonTwitter,
          efpNotificationEmail: this.feedbackForm.efpNotificationEmail,
          efpNotificationWebhookURL:
            this.feedbackForm.efpNotificationWebhookURL,
          efpReaderNamePlaceholder: this.feedbackForm.efpReaderNamePlaceholder,
          efpReaderEmailPlaceholder:
            this.feedbackForm.efpReaderEmailPlaceholder,
          efpTextMsgText: this.feedbackForm.efpTextMsgText,
          efpVoiceText: this.feedbackForm.efpVoiceText,
          efpAllowAudioFeedback: this.feedbackForm.efpAllowAudioFeedback,
          efpVoiceRemainingText: this.feedbackForm.efpVoiceRemainingText,
          showBranding: this.feedbackForm.showBranding,
          efpEnabled: this.feedbackForm.efpEnabled,
          efpAllowBlankFeedback: this.feedbackForm.efpAllowBlankFeedback,
          efpPrefillEmail: this.feedbackForm.efpPrefillEmail,
        };
      }
      if (
        this.feedbackForm.efpThumbsoption4ReasonHeader !== undefined &&
        this.feedbackForm.efpThumbsoption4ReasonHeader !== null
      ) {
        feedbackFormSend.config.efpThumbsoption4ReasonHeader =
          this.feedbackForm.efpThumbsoption4ReasonHeader;
      }
      if (
        this.feedbackForm.efpThumbsoption5ReasonHeader !== undefined &&
        this.feedbackForm.efpThumbsoption5ReasonHeader !== null
      ) {
        feedbackFormSend.config.efpThumbsoption5ReasonHeader =
          this.feedbackForm.efpThumbsoption5ReasonHeader;
      }
      var self = this;
      this.$store.dispatch("getAPIToken").then((token) => {
        atomic(self.apiHost + "feedforms/" + self.formId, {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + token,
            "Content-type": "application/json",
          },
          data: feedbackFormSend,
        })
          .then(function (response) {
            self.isSaving = false;
            self.updateData(self, response);
            self.$buefy.toast.open({
              duration: 3000,
              message: `Survey "${self.feedbackForm.formName}" successfully saved.`,
              type: "is-success",
            });
            //console.log(response.data); // xhr.responseText
            //console.log(response.xhr); // full response
          })
          .catch(function (error) {
            self.isSaving = false;
            self.$buefy.toast.open({
              duration: 3000,
              message: `OMG, saving your survey failed. It was us, not you and the team was already notified. Please try again later.`,
              type: "is-danger",
            });
            console.log(error.status); // xhr.status
            console.log(error.statusText); // xhr.statusText
          });
      });
    },
    confirmDelete() {
      if (this.account.subscribed) {
        this.$buefy.dialog.confirm({
          message:
            "Are you sure you want to delete the survey? It is gone forever once you confirm, including all extended feedback it collected.",
          type: "is-danger",
          onConfirm: async () => {
            console.log("confirmed delete dialog");
            var self = this;
            self.isSaving = true;
            this.$store.dispatch("getAPIToken").then((token) => {
              atomic(self.apiHost + "feedforms/" + self.formId, {
                method: "DELETE",
                headers: {
                  Authorization: "Bearer " + token,
                  "Content-type": "application/json",
                },
              })
                .then(function (response) {
                  self.$router.push("/feedbacks");
                  self.$buefy.toast.open({
                    duration: 3000,
                    message: `Survey "${self.feedbackForm.formName}" successfully deleted.`,
                    type: "is-success",
                  });
                  //console.log(response.data); // xhr.responseText
                  //console.log(response.xhr); // full response
                })
                .catch(function (error) {
                  self.isSaving = false;
                  self.$buefy.toast.open({
                    duration: 3000,
                    message: `Sorry but the survey could not be deleted. Please try again later.`,
                    type: "is-danger",
                  });
                  console.log(error.status); // xhr.status
                  console.log(error.statusText); // xhr.statusText
                });
            });
          },
        });
      } else {
        this.$buefy.dialog.confirm({
          message:
            "You can only delete this form on the Professional plan. Want to learn more about it?",
          type: "is-info",
          confirmText: "Show me",
          onConfirm: async () => {
            this.$router.push("/upgrade");
          },
        });
      }
    },
    confirmReset() {
      if (this.account.subscribed) {
        this.$buefy.dialog.confirm({
          message:
            "Are you sure you want to reset the survey? It deletes all votes and feedback once you confirm. There is no undo!",
          type: "is-danger",
          onConfirm: async () => {
            console.log("confirmed reset dialog");
            var self = this;
            self.isSaving = true;
            this.$store.dispatch("getAPIToken").then((token) => {
              atomic(self.apiHost + "feedforms/" + self.formId + "/reset", {
                method: "PUT",
                headers: {
                  Authorization: "Bearer " + token,
                  "Content-type": "application/json",
                },
              })
                .then(function (response) {
                  self.isSaving = false;
                  self.votesUp = 0;
                  self.votesOk = 0;
                  self.votesDown = 0;
                  self.votesOption4 = 0;
                  self.votesOption5 = 0;
                  self.votesTotal = 0;
                  self.reasons = [];

                  self.$buefy.toast.open({
                    duration: 3000,
                    message: `Survey "${self.feedbackForm.formName}" successfully resetted.`,
                    type: "is-success",
                  });
                  //console.log(response.data); // xhr.responseText
                  //console.log(response.xhr); // full response
                })
                .catch(function (error) {
                  self.isSaving = false;
                  self.$buefy.toast.open({
                    duration: 3000,
                    message: `Sorry but the survey could not be resetted. Please try again later.`,
                    type: "is-danger",
                  });
                  console.log(error.status); // xhr.status
                  console.log(error.statusText); // xhr.statusText
                });
            });
          },
        });
      } else {
        this.$buefy.dialog.confirm({
          message:
            "You can only reset this survey on the Professional or Business plans. Want to learn more about it?",
          type: "is-info",
          confirmText: "Show me",
          onConfirm: async () => {
            this.$router.push("/upgrade");
          },
        });
      }
    },
    feedbackDeleted: function (feedbackId) {
      this.reasons.splice(
        this.reasons.findIndex((v) => v.id === feedbackId),
        1
      );
    },

    filterComments: function(e) {
      console.log("ya", this.allReasons)
      this.allFilteredReasons = this.allReasons.filter(item => {
        const scoreMatch = (this.commentFilterScore === 'all') || item.score === parseInt(this.commentFilterScore);
         const textMatch = this.commentFilterReason === '' || item.reason.toLowerCase().includes(this.commentFilterReason.toLowerCase());
        return scoreMatch && textMatch;
      });
      this.reasonsPages = Math.ceil(this.allFilteredReasons.length / this.reasonsPerPage)
      this.reasons = this.allFilteredReasons.slice(0, this.reasonsPerPage);
      this.reasonsCurrentPage = 1;
    },
    reasonsCurrentPageChanged: function (page) {
      this.reasonsCurrentPage = page;
      this.reasons = this.allFilteredReasons.slice((page - 1) * this.reasonsPerPage, page * this.reasonsPerPage);
    },
  },
  computed: {
    ...mapState(["user", "account"]),
    surveyTypeText() {
      if (this.isWebRating) {
        return "Web Rating widget";
      } else if (this.isOnetimeForm) {
        return "poll";
      }
      return "survey";
    },
    formName() {
      return this.feedbackForm.formName;
    },
    totalVotes() {
      return (
        this.votesUp +
        this.votesOk +
        this.votesDown +
        this.votesOption4 +
        this.votesOption5
      );
    },
    votesUpPercentage() {
      if (this.votesUp === 0) {
        return 0;
      }
      return Math.round((this.votesUp / this.totalVotes) * 100);
    },
    votesOkPercentage() {
      if (this.votesOk === 0) {
        return 0;
      }
      return Math.round((this.votesOk / this.totalVotes) * 100);
    },
    votesDownPercentage() {
      if (this.votesDown === 0) {
        return 0;
      }
      return Math.round((this.votesDown / this.totalVotes) * 100);
    },
    votesOption4Percentage() {
      if (this.votesOption4 === 0) {
        return 0;
      }
      return Math.round((this.votesOption4 / this.totalVotes) * 100);
    },
    votesOption5Percentage() {
      if (this.votesOption5 === 0) {
        return 0;
      }
      return Math.round((this.votesOption5 / this.totalVotes) * 100);
    },
    isNewsletter() {
      return this.feedbackForm.formType === "newsletter";
    },
    isOnetimeForm() {
      return this.feedbackForm.formType === "onetime";
    },
    isWebRating() {
      return this.feedbackForm.formType === "webrating";
    },
  },
  watch: {
    formName: function (val) {
      this.saveBtnEnabled = val !== null && val !== "";
    },
    activeTab: function (val) {
      trackEvent(this.$store.state.user.id, "survey-edit-maintab-view-" + this.activeTab)
    }
  },
};
</script>
